interface nutrientIconsProperties {
  [key: string]: string;
}

const iconList: nutrientIconsProperties = {
  "chevron down": "far fa-chevron-down",
  "chevron up": "far fa-chevron-up",
  "chevron right": "far fa-chevron-right",
  "chevron left": "far fa-chevron-left",
  "arrow left": "far fa-arrow-left",
  "arrow right": "far fa-arrow-right",
  sort: "far fa-sort-alt",
  columns: "far fa-columns",
  list: "far fa-list",
  table: "far fa-th-list",
  "more vertical": "far fa-ellipsis-v",
  "more horizontal": "far fa-ellipsis-h",
  filter: "far fa-filter",
  search: "far fa-search",
  zoom: "far fa-search-plus",
  "add-plus": "far fa-plus",
  "remove-minus": "far fa-minus",
  reset: "far fa-redo-alt",
  warning: "far fa-exclamation-circle",
  error: "fal fa-times-circle",
  "check circle": "far fa-check-circle",
  edit: "far fa-pencil",
  draw: "far fa-pencil-ruler",
  cut: "far fa-cut",
  measure: "far fa-ruler-combined",
  "merge or group": "far fa-object-group",
  select: "far fa-mouse-pointer",
  link: "far fa-link",
  unlink: "far fa-unlink",
  attachment: "far fa-paperclip",
  download: "far fa-file-download",
  upload: "far fa-file-upload",
  user: "far fa-user",
  "user add": "far fa-user-plus",
  "user edit": "far fa-user-edit",
  contacts: "far fa-users",
  customers: "far fa-handshake",
  supplier: "far fa-box-open",
  inventory: "far fa-warehouse-alt",
  farm: "far fa-farm",
  machines: "far fa-tractor",
  dashboard: "far fa-tachometer-alt",
  weather: "far fa-cloud-rain",
  contracts: "far fa-file-contract",
  admissions: "far fa-shield-check",
  disease: "far fa-disease",
  planning: "far fa-clipboard-list-check",
  "storage location": "far fa-truck",
  "test-location": "far fa-vial",
  soiltest: "far fa-microscope",
  "calendar edit": "far fa-calendar-edit",
  calendar: "far fa-calendar",
  fumigation: "far fa-eye-dropper",
  tillage: "far fa-shovel",
  preparation: "far fa-wheat",
  planting: "far fa-hand-holding-seedling",
  fertilisation: "far fa-sack",
  protection: "far fa-shower",
  irrigation: "far icn_irrigation-83",
  observation: "far fa-eye",
  "password hide": "far fa-eye-slash",
  harvesting: "far fa-apple-crate",
  "information circle": "far fa-info-circle",
  "question circle": "far fa-question-circle",
  close: "far fa-times",
  map: "far fa-map",
  "location pinpoint": "far fa-location",
  "location marker": "far fa-map-marker-alt",
  notifications: "far fa-bell",
  hamburger: "far fa-bars",
  language: "far fa-globe",
  logout: "far fa-sign-out",
  cropfields: "far fa-layer-group",
  "cropfields add": "far fa-layer-plus",
  mail: "far fa-envelope",
  check: "far fa-check",
  spinner: "fad fa-spinner-third fa-spin",
  clock: "far fa-clock",
  "calendar day": "far fa-calendar-day",
  delete: "far fa-trash",
  danger: "far fa-ban",
  cloudfarm: "far fa-cloud-upload",
  "chevron circle left": "far fa-chevron-circle-left",
  "chevron circle right": "far fa-chevron-circle-right",
  extension: "far fa-puzzle-piece",
  lot: "far fa-clone",
  help: "far fa-question-circle",
  task: "far fa-tasks",
  label: "far fa-tag",
  job: "far fa-briefcase",
  assign: "far fa-user-check",
  dragdrop: "far fa-grip-vertical",
  clear: "fas fa-times-circle",
  "import-export": "far fa-exchange-alt",
  "chart-details": "far fa-chart-line",
  wind: "far fa-wind",
  temperature: "far fa-thermometer-half",
  sun: "far fa-sun",
  rain: "far fa-cloud-showers",
  humidity: "far fa-tint",
  cloudy: "far fa-clouds",
  financial: "far fa-sack-dollar",
  import: "far fa-file-import",
  export: "far fa-file-export",
  insects: "far far fa-bug",
  settings: "far fa-cog",
  "external link": "far fa-external-link",
  apps: "far fa-shapes",
  simple: "far fa-lightbulb-on",
  autofill: "far fa-magic",
  sparkles: "far fa-sparkles",
};

export default iconList;
